console.groupCollapsed(
  `%cAeronet`,
  "color: #00afe9; font-size: 16px; font-weight: bold;"
);
fetch('/app/build-info.json')
  .then(r => r.json())
  .then(info => {
    console.info(`Version: ${info.version}`);
    console.info(`Branch: ${info.branch}`);
    console.info(`Commit: ${info.commit}`);
    console.info(`Build Time: ${info.buildTime}`);
  })
  .catch(() => {
    console.info(`Version: ${process.env.REACT_APP_VERSION}`);
    console.info(`Build: ${process.env.REACT_APP_BUILD_VERSION}`);
  });
console.groupEnd();